import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { INascarViewModel } from 'app/models/INascarViewModel';
import { IOrgUserRaceFilter } from 'app/models/IOrgUserRaceFilter';
import { ISeason } from 'app/models/ISeason';
import { BaseService } from 'app/services/base.service';
import { IGame } from '../models/IGame';
import { ISeasonWeek } from '../models/ISeasonWeek';
import { IOrgSeasonWeek } from '../models/IOrgSeasonWeek';





let config = require('../../config').appConfig;

@Injectable()
export class NflService {
    // public nascar: INascarViewModel;
    //public games: IGame[];
    seasonWeek: ISeasonWeek = { season: null, week: null, orgId: null, userId: null };
    constructor(private baseService: BaseService) {
    }

    private convertModel(model: IOrgSeasonWeek) : ISeasonWeek {
        return {orgId: model.org.id, season: model.season.name, seasonType: model.seasonType, week: model.week.name, userId: model.userId} as ISeasonWeek;
    }

    getOrgGames(model : IOrgSeasonWeek) {
        var result = this.convertModel(model);
        return this.baseService.sendHttpPost('/nfl/getorggames', result); 
    }

    createOrgGamesWithOdds(model : IOrgSeasonWeek) {
        var result = this.convertModel(model);
        return this.baseService.sendHttpPost('/nfl/createorggameswithodds', result)
    }

    updateOrgGame(game: IGame) {
        return this.baseService.sendHttpPost('/nfl/updateOrgGame', game).subscribe(result => {
            result as IGame[];
        });
    }

    updateOrgUserGame(game: IGame) {
        return this.baseService.sendHttpPost('/nfl/updateOrgUserGame', game)
    }

    getGames(model: IOrgSeasonWeek){
        var result = this.convertModel(model);
        return this.baseService.sendHttpPost('/nfl/getgames', result);
    }

    updateScores(model: IOrgSeasonWeek) {
        var result = this.convertModel(model);
        return this.baseService.sendHttpPost('/nfl/updatescores', result)
    }

    updateOrgGameScores(seasonWeek: IOrgSeasonWeek) {
        if (seasonWeek.week.name > 18)
            seasonWeek.seasonType = "POST";
        else
            seasonWeek.seasonType = "REG";
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/nfl/updateorgscores', result)
    }

    // getSeasonWeeks() {
    //     return this.baseService.sendHttpGet('/nfl/getseasonweeks');
    // }

    getGameResults(seasonWeek: IOrgSeasonWeek) {
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/nfl/getgameresults', result);
    }
    getGameSeasonResults(seasonWeek: IOrgSeasonWeek) {
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/nfl/getgameseasonresults', result);
    }

    getGamePlayoffSeasonResults(seasonWeek: IOrgSeasonWeek) {
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/nfl/getgameplayoffseasonresults', result);
    }

    getNflUsers(seasonWeek: IOrgSeasonWeek) {
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/nfl/getfootballusers', result);
    }

    getUserGames(seasonWeek: IOrgSeasonWeek) {
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/nfl/getusergames', result);
    }

    getSeasonWeeks(season: ISeason) {
        return this.baseService.sendHttpPost('/nfl/getseasonweeks', season)
    }

 
}


// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/nfl.service.ts